import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import Label from 'components/form/Label/Label';
import { Button } from 'components/form/Button/index';
import classnames from 'classnames';
import { SUBSCRIPTION_VERTICAL } from 'types/mrph.vertical.constants';
import { useEventHandler } from 'hook/event.hook';
import { useHistory } from 'react-router-dom';

const GoToFullCreditReportModuleView = props => {
  const { className } = props;
  const eventHandler = useEventHandler();
  const history = useHistory();

  const goToFullCreditReportClass = classnames('flex-column', className);

  const handleGoToCreditReports = () => {
    eventHandler(CLICK, {
      'Module Name': 'Grade Dial 3B',
      'Click Type': 'TU3B Report Link',
      Vertical: SUBSCRIPTION_VERTICAL,
    });
    history?.push('/creditReports/tabs?nav=premiumCreditReports');
  };

  return (
    <FlexContainer className={goToFullCreditReportClass}>
      <Label className="text-12 italic center-xy">
        Based on VantageScore® 3.0
      </Label>
      <FlexContainer
        className={'justify-center'}
        onClick={handleGoToCreditReports}
      >
        <Button mrphType="link" className="text-20 m-text-16 m-margT0">
          Go to full credit report
        </Button>
      </FlexContainer>
    </FlexContainer>
  );
};

export default GoToFullCreditReportModuleView;
